
let Drawers = function () {

    let selectors = {
        drawerTrigger: document.querySelectorAll('[data-drawer-trigger]'),
        mobileMenu: document.querySelectorAll('[data-mobile-menu]'),
        search: document.querySelector('[data-search-form]'),
        siteDrawers: document.querySelectorAll('.drawer')
    }


    let checkSearch = function (){
        
        if( selectors.search.classList.contains('is--active')){
            selectors.search.classList.add('is--active')
        };
    };

    let scrollingNavHide = function () {

        let scrollingNav = document.querySelector('[data-scrolling-nav]');

        if(scrollingNav){
            let scrollingNavParent = scrollingNav.parentElement;

            if( scrollingNav.innerHTML.length > 0 && window.getComputedStyle(scrollingNavParent).display == 'block' ){
                scrollingNav.style.display = "none";
            }
        }
    };

    let scrollingNavShow = function () {

        let scrollingNav = document.querySelector('[data-scrolling-nav]');
        if(scrollingNav){
            let scrollingNavParent = scrollingNav.parentElement;

            if( scrollingNav.innerHTML.length > 0 && window.getComputedStyle(scrollingNavParent).display == 'none' ){
                scrollingNav.style.display = "block";
            }
        }
    };

    let closeTarget = function ( target ){
        
        if( document.querySelector(target).classList.contains('is--active') ){
            
            scrollingNavShow();
            document.querySelector('body').classList.remove('no--scroll');
            document.querySelector(target).classList.remove('is--active');
            if(target === '[data-mini-cart]') {
                document.querySelector(target).removeAttribute('open');
                document.querySelector('.cart-mini-container').classList.remove('cart-mini-container--open');
                const drawer = document.querySelector('.cart-mini-container');
                drawer.querySelector('cart-mini').addEventListener("transitionend", function handler() {
                    drawer.style.display = "none";
                    drawer.querySelector('cart-mini').removeEventListener("transitionend", handler);
                });
            }

            if(target === '[data-mobile-menu]') {
                const drawer = document.querySelector(target);
                drawer.addEventListener("transitionend", function handler() {
                    drawer.style.display = "none";
                    drawer.removeEventListener("transitionend", handler);
                    document.querySelector('.header__nav--right .nav--header__item.item--mobile [data-target="data-mobile-menu"]').focus();
                });
            }

            document.dispatchEvent(new Event("drawer:close", [document.querySelector(target)]));
        }
    };

    var openTarget = function ( target ){
        // is open
        if (document.querySelector(target).classList.contains('is--active') == false) {
             // Check if the scrolling nav is active and hide it
             scrollingNavHide();

             // Set the top position of the drawer
            // setTop(target);

            // Add Classes
            const drawer = document.querySelector(target);
            drawer.style.display = "block";
            drawer.offsetHeight;

            drawer.classList.add('is--active');
            drawer.focus();
            if(target === '[data-mobile-menu]') {
                document.querySelector('.mobile-menu__image-links .mobile-menu__item.active  a').focus();
                trapFocus(drawer);
            }

            function trapFocus(drawer) {
                var firstFocusableElement = drawer.querySelector('.mobile-menu__head [data-drawer-trigger]');
                var lastFocusableElement = accessibilityHelpers.getFocusableElement(drawer, 'last');

                drawer.addEventListener('keydown', function(e) {
                    if(e.target == firstFocusableElement && e.key == 'Tab' && e.shiftKey) {
                        e.preventDefault();
                        lastFocusableElement.focus();
                    } else if(e.target == lastFocusableElement && e.key == 'Tab' && !e.shiftKey) {
                        e.preventDefault();
                        firstFocusableElement.focus();
                    }
                });
            }

            // Trigger the drawer open event
            document.dispatchEvent(new Event("drawer:open", [document.querySelector(target)]));
        }
    };

    var toggleTarget = function (target){

        // is open
        if( document.querySelector(target).classList.contains('is--active') ){
            // Run the close drawer function on target
            closeTarget(target);

        // is closed
        }else{

            // check if the search is active
            checkSearch();

            // Run the open drawer function on target
            openTarget(target);
            
        }
    };
    
    selectors.drawerTrigger.forEach(trigger => {
        trigger.addEventListener("click", function (e){
            e.preventDefault();
            
            let target = '['+this.dataset.target+']';
    
            toggleTarget(target);
        }); 
    });

    // document.addEventListener('drawer:open', function (event, drawer) {
    //     if( drawer.classList.contains('mobile-menu') ){
    //         document.querySelector('[data-target="data-mobile-menu"]').classList.add('is--active');
    //     }
    // });

    // // needed to remove active class to mobile menu trigger
    // document.addEventListener('drawer:close', function (event, drawer) {
    //     if( drawer.classList.contains('mobile-menu') ){
            
    //         document.querySelector('[data-target="data-mobile-menu"]').classList.remove('is--active');
    //     }
    // });

    document.addEventListener('keyup', function(e) {
        if(e.key == 'Escape'){

            selectors.siteDrawers.forEach((drawer) => {
                if(drawer.classList.contains('is--active')){
                    drawer.classList.remove('is--active');
                    document.body.classList.remove('no--scroll');
                }
            });
        }
    });

    if(document.querySelector('[data-mini-cart-notes-trigger]')){
        document.querySelector('[data-mini-cart-notes-trigger]').addEventListener('click', (e) => {
            document.querySelector('[data-mini-cart-notes]').classList.toggle('is--visible');
        })
    }

}();